"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayStatus = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _expander = _interopRequireDefault(require("../expander"));
var _fieldStatus = _interopRequireDefault(require("../field-status"));
var _theme = require("../theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getDisplayStatus = exports.getDisplayStatus = function getDisplayStatus(_ref) {
  var displayStatus = _ref.displayStatus,
    error = _ref.error,
    errorMessage = _ref.errorMessage;
  var hasError = Boolean(error && errorMessage);
  return displayStatus || hasError;
};
var InputValidationMessage = function InputValidationMessage(_ref2) {
  var customFieldStatus = _ref2.customFieldStatus,
    displayStatus = _ref2.displayStatus,
    error = _ref2.error,
    errorMessage = _ref2.errorMessage,
    id = _ref2.id;
  var shouldDisplay = getDisplayStatus({
    displayStatus: displayStatus,
    error: error,
    errorMessage: errorMessage
  });
  var message = customFieldStatus ? errorMessage : /*#__PURE__*/_react["default"].createElement(_fieldStatus["default"], {
    error: true
  }, errorMessage);
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var colorClass = theme === _theme.themes.dark ? 'color-textWhite' : '';
    return /*#__PURE__*/_react["default"].createElement(_expander["default"], {
      isExpanded: shouldDisplay
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "block pt1 ".concat(colorClass),
      id: id
    }, message));
  });
};
InputValidationMessage.displayName = InputValidationMessage;
InputValidationMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A flag indicating that the field uses a custom element to display field status
   * and should not wrap error messages in a `FieldStatus` component.
   */
  customFieldStatus: _propTypes["default"].bool,
  /**
   * A flag indicating that the field should display its error message irrespective of the field's
   * error status. If set to `true`, the error message will display no matter what. If set to
   * `false`, it will never display.
   */
  displayStatus: _propTypes["default"].bool,
  /**
   * A flag indicating that the input is in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * A message to display when the input is in an error state. Wrapped in a `FieldStatus`
   * component by default.
   */
  errorMessage: _propTypes["default"].node,
  /**
   * An HTML `id` attribute, used to associate the message with its corresponding input element.
   */
  id: _propTypes["default"].string.isRequired
} : {};
var _default = exports["default"] = InputValidationMessage;